export const SUSPICIOUS_LOGIN = 'suspicious-login'
export const TICKET_RESPONSE = 'ticket-responded'

export const CARD_EXPIRING = 'card_expiring_soon'

export const SUBSCRIPTION_EXPIRED = 'subscription-expired'
export const MODEL_SUBSCRIPTION_EXPIRED = 'fans-subscription-expired'

export const SUBSCRIPTION_EXPIRING = 'subscription-expiring'
export const SUBSCRIPTION_PRICE_CHANGE = 'subscription-price-change'
export const ACCOUNT_COMPROMISE_2FA_REQUIRED =
    'account-compromise-2fa-required'
export const NEW_POST = 'new-post'
export const ACCOUNT_COMPROMISED = 'account-compromised'
export const NEW_COMMENT_COMMENT = 'new-comment-comment'
export const NEW_VIDEO_COMMENT = 'new-video-comment'
export const NEW_PHOTO_COMMENT = 'new-photo-comment'
export const NEW_POST_COMMENT = 'new-post-comment'
export const PAYOUT_FAILED = 'payout-failed'
export const NEW_POST_LIKE = 'new-post-like'
export const POLL_RESPONSE = 'poll-response'
export const NEW_PHOTO_LIKE = 'new-photo-like'
export const NEW_STORY_LIKE = 'new-story-like'
export const NEW_VIDEO_LIKE = 'new-video-like'
export const NEW_COMMENT_LIKE = 'new-comment-like'
export const NEW_TIP_LIKE = 'new-tip-like'
export const NEW_PURCHASE_LIKE = 'new-purchase-like'

export const PRIVATE_STREAM_REQUEST = 'private-stream-request'
export const STREAM_STARTED = 'stream-started'

export const POST_FINISHED = 'post-finished'
export const PAYOUT_METHOD_REJECTED = 'payout-method-rejected'
export const POST_REMOVED = 'post-removed-for-violation'
export const NEW_UPCOMING_STREAM_REMINDER = 'new-upcoming-stream-reminder'

export const NEW_PREMIUM_CONTENT_PURCHASE = 'new-premium-content-purchased'
export const NEW_MESSAGE = 'new-message-notification'
export const NEW_MESSAGE_PURCHASE = 'new-message-purchase'
export const NEW_TIP = 'new-model-tip'
export const NEW_POST_TIP = 'new-post-tip'
export const NEW_STORY_TIP = 'new-story-tip'
export const NEW_POST_TIP_LIKE = 'new-post-tip-like'

export const NEW_MENTION = 'new-mention'

export const NEW_SUBSCRIBER = 'new-subscriber'
export const NEW_REFERRAL = 'new-referral'
export const NEW_INCOMING_FRIEND_REQUEST = 'new-friend-request'
export const NEW_ACCEPTED_FRIEND_REQUEST = 'accept-friend-request'
export const Message_Finished = 'message-finished'
